export enum CLAIMS_SCREEN_NAMES {
  CLAIM_SUBMISSION = 'claim submission page',
  CLAIM_EDIT = 'claim edit page',
  CLAIM_SUBMIT_SUCCESS = 'claim submitted successfully',
  CLAIM_CONFIRM_CANCELLATION_MODAL = 'cancel claim modal',
  CLAIM_OVERVIEW = 'claim overview',
}
